
define('eteration/eteration-urlparser',['jquery'], function($) {   

	
	var getUrlVars = function(){
	    var vars = [], hash;
		var decodedUrl = decodeURIComponent(window.location.href);
		var hashes = decodedUrl.slice(window.location.href.indexOf('?') + 1).split('&');
	    for(var i = 0; i < hashes.length; i++)
	    {
	      hash = hashes[i].split('=');
	      vars.push(hash[0]);
	      vars[hash[0]] = hash[1];
	    }
	    return vars;
	 };

	  
	 var getUrlVar = function(name){
	    return getUrlVars()[name];
	 };

	 var getUrlVarsLinkParam = function(url){
	    var vars = [], hash;
	    var hashes = url.slice(url.indexOf('?') + 1).split('&');
	    for(var i = 0; i < hashes.length; i++)
	    {
	      hash = hashes[i].split('=');
	      vars.push(hash[0]);
	      vars[hash[0]] = hash[1];
	    }
	    return vars;
	 };

	  
	 var getUrlVarLinkParam = function(name){
	    return getUrlVarsLinkParam(url)[name];
	 };

	 var urlSingleParamParser = function(){
		 
		    var param = window.location.href.split('#')[1];

		    return param;
		 
	 }
    
	 
	 var urlMultiParamParser = function(){
		 
		    var vars = [];
		    var hashes = window.location.href.slice(window.location.href.indexOf('#') + 1).split('/');
		    for(var i = 0; i < hashes.length; i+=2)
		    {
		      vars.push(hashes[i]);
		      vars[hashes[i]] = hashes[i+1];
		    }
		    return vars;
		 
	 }
	 
		
	var getLangAndRegionCodeFromURL = function(){
	    
	    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
	    
	    var hashes2 = hashes[2].split(':');
	    var langRegionCodePair = hashes2[1].split('-');
	    
	      
	    return langRegionCodePair;
	 };
  
	  
	  return {
    	getUrlVars :getUrlVars,
		getUrlVar :getUrlVar,
		getUrlVarsLinkParam : getUrlVarsLinkParam,
		getUrlVarLinkParam : getUrlVarLinkParam,
    	urlSingleParamParser : urlSingleParamParser,
    	urlMultiParamParser : urlMultiParamParser,
    	getLangAndRegionCodeFromURL : getLangAndRegionCodeFromURL
    };
    
});
